import axios from "axios";
import baseUrl from "../pages/BaseUrl/url";

const API_URL = import.meta.env.REACT_APP_API_BASE_URL;
// console.log("baseUrl", baseUrl);
export const client = axios.create({
  baseURL: baseUrl,
});
